import React from 'react';
import PropTypes from 'prop-types';
import SovosTable from 's1-ui/sovos-table/SovosTable';
import SovosTableCard from 's1-ui/sovos-table-card/SovosTableCard';
import SovosToolbar from 's1-ui/sovos-toolbar/SovosToolbar';
import SovosToolbarBulkActions from 's1-ui/sovos-toolbar/components/SovosToolbarBulkActions';
import SovosPaginationFooter from 's1-ui/sovos-pagination-footer/SovosPaginationFooter';
import LinearProgress from 'material-ui/LinearProgress';
import './genericGrid.scss';

class GenericGrid extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.pageNumber !== state.page) {
      return {
        page: props.pageNumber
      };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      itemsPerPage: props.initialPageSize,
      page: props.pageNumber,
      selectedRows: []
    };
  }

  calculateEndItem = () => {
    const maximumItemsOnPage = this.state.itemsPerPage * (this.state.page + 1);
    if (maximumItemsOnPage > this.props.totalItems) {
      return this.props.totalItems;
    }
    return maximumItemsOnPage;
  };

  getStartItem = () => (this.props.totalItems ? ((this.state.itemsPerPage * (this.state.page)) + 1) : 0);

  handlePrevPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if(oldState.page > 0 ) {
        this.props.onPageChange(oldState.page - 1, oldState.itemsPerPage);
        return ({
          page: oldState.page - 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handleNextPage = ev => {
    ev.preventDefault();
    this.setState(oldState => {
      if((oldState.page + 1) * oldState.itemsPerPage < this.props.totalItems) {
        this.props.onPageChange(oldState.page + 1, oldState.itemsPerPage);
        return ({
          page: oldState.page + 1
        });
      }
      else {
        return ({});
      }
    });
  };

  handlePerPageChanged = ev => {
    const itemsPerPage = ev.target.value;
    this.setState({ page: 0, itemsPerPage });
    this.props.onPageChange(0, itemsPerPage);
  };

  handleRowSelection = rows => {
    this.setState({ selectedRows: [ ...rows ] });
    this.props.onRowSelection([ ...rows ]);
  };

  render() {
    const { data, columns, totalItems, itemsPerPageOptions, withPagination, onRowClick, selectable, loadingData, toolBarElements, bulkActionsElements } = this.props;
    return(
      <div className={ `generic-grid__main-container${ loadingData ? ' blur-content' : '' }` }>
        <React.Fragment>
          <SovosTableCard>
            <SovosToolbar style={ { justifyContent: 'start' } }>
              <SovosToolbarBulkActions count={ this.state.selectedRows.length }>
                { bulkActionsElements.map(element => element) }
              </SovosToolbarBulkActions>
              { toolBarElements.map(element => element) }
            </SovosToolbar>
            <SovosTable
              columns={ columns }
              data={ data }
              onRowSelection={ this.handleRowSelection }
              selectable={ selectable }
              onRowClick={ onRowClick }
            />
            {
              data.length > 0 && withPagination &&
              <SovosPaginationFooter
                endItem={ this.calculateEndItem() }
                itemsPerPage={ this.state.itemsPerPage }
                startItem={ this.getStartItem() }
                totalItems={ totalItems }
                onPrevClicked={ this.handlePrevPage }
                onNextClicked={ this.handleNextPage }
                onPerPageChanged={ this.handlePerPageChanged }
                itemsPerPageOptions={ itemsPerPageOptions }
              />
            }
          </SovosTableCard>
          {
            loadingData && <div className={ 'generic-grid__blocking-layer' }>
              <LinearProgress mode="indeterminate"/>
            </div>
          }
        </React.Fragment>
      </div>
    );
  }
}

GenericGrid.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  totalItems: PropTypes.number,
  itemsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  withPagination: PropTypes.bool,
  onPageChange: PropTypes.func,
  initialPageSize: PropTypes.number,
  pageNumber: PropTypes.number,
  onRowClick: PropTypes.func,
  onRowSelection: PropTypes.func,
  selectable: PropTypes.bool,
  loadingData: PropTypes.bool,
  toolBarElements: PropTypes.arrayOf(PropTypes.node),
  bulkActionsElements: PropTypes.arrayOf(PropTypes.node)
};

GenericGrid.defaultProps = {
  onCellClick: () => null,
  totalItems: 0,
  itemsPerPageOptions: [ 10, 25, 50, 100],
  onPageChange: () => null,
  onRowSelection: () => null,
  withPagination: true,
  initialPageSize: 10,
  pageNumber: 0,
  onRowClick: () => null,
  selectable: true,
  loadingData: false,
  toolBarElements: [],
  bulkActionsElements: []
};

export default GenericGrid;



// WEBPACK FOOTER //
// ./src/shared/components/genericGrid/GenericGrid.js